// src/utils/User-taskcheck.js
import { ElMessageBox, ElMessage } from 'element-plus'; // 若用其他UI库，替换为对应弹窗组件
import axios from 'axios';

// 登录状态校验（判断localStorage中是否有有效token）
export const checkLoginStatus = () => {
  const token = localStorage.getItem('token');
  // 简单校验：token存在且非空
  return !!token;
};

// 弹出登录提示弹窗（可自定义文案/按钮）
export const showLoginDialog = (message = '请先登录后再进行操作') => {
  return ElMessageBox.confirm(
    message,
    '登录提示',
    {
      confirmButtonText: '去登录',
      cancelButtonText: '取消',
      type: 'warning',
      draggable: true
    }
  ).then(() => {
    // 点击「去登录」的逻辑：跳转到登录页（根据项目路由调整）
    window.location.href = '/login'; // 若用vue-router，可替换为 router.push('/login')
  }).catch(() => {
    ElMessage.info('已取消登录操作');
  });
};

// 刷新 token 逻辑
export const refreshToken = async () => {
  const refresh = localStorage.getItem('refresh');
  if (!refresh) return false;
  
  try {
    const formData = new FormData();
    formData.append('refresh', refresh);
    
    // 使用新的 axios 实例避免拦截器死循环
    const res = await axios.post('/api/membership/jwt/refresh/', formData, {
      headers: {
        // 浏览器会自动设置 multipart/form-data
      }
    });
    
    if (res.data && res.data.access) {
      localStorage.setItem('token', res.data.access);
      return true;
    }
    return false;
  } catch (error) {
    console.error('Refresh token failed:', error);
    return false;
  }
};

// Axios 请求拦截器：统一校验 token 有效性
export const setupTokenInterceptor = () => {
  // 请求拦截：添加token到请求头（基础逻辑，若已有可整合）
  axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  // 响应拦截：捕获 token 无效/未授权错误
  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      // 捕获 401/Unauthorized 或 token 无效场景
      const status = error.response?.status;
      const errorMsg = error.response?.data?.message || error.message;

      if ((status === 401 || errorMsg.includes('token无效') || errorMsg.includes('Unauthorized')) && !originalRequest._retry) {
        originalRequest._retry = true;
        
        // 尝试刷新 token
        const isRefreshed = await refreshToken();
        if (isRefreshed) {
          // 刷新成功，更新请求头并重新发送请求
          const newToken = localStorage.getItem('token');
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return axios(originalRequest);
        } else {
          // 刷新失败，清除无效token
          localStorage.removeItem('token');
          localStorage.removeItem('refresh');
          // 弹出重新登录提示
          ElMessageBox.confirm(
            '登录状态已失效，请重新登录',
            'token无效',
            {
              confirmButtonText: '重新登录',
              cancelButtonText: '取消',
              type: 'error',
              draggable: true
            }
          ).then(() => {
            window.location.href = '/login'; // 跳转到登录页
          }).catch(() => {
            ElMessage.warning('已取消重新登录');
          });
        }
      }
      return Promise.reject(error);
    }
  );
};

// 生成任务前置校验（整合登录状态+token校验）
export const taskPreCheck = async (callback) => {
  // 1. 先校验是否登录
  if (!checkLoginStatus()) {
    await showLoginDialog();
    return false; // 未登录，终止后续操作
  }

  // 3. 校验通过，执行传入的生成任务逻辑
  if (callback) {
    callback();
  }
  return true;
};